import React from 'react';

/**
 * Official full-colour TikTok mark: cyan and magenta copies of the note offset
 * behind a white one (the "glitch" look). The fills are hard-coded rather than
 * currentColor because the three layers are the logo — the white note assumes a
 * dark surface, which is what the app renders on.
 *
 * Only for surfaces that tint per platform (see ExternalLinkIcon). Anywhere the
 * icon sits in a row of muted platform glyphs — the supported-platforms line, the
 * media menu — use the monochrome TikTokIcon so it greys out with its neighbours.
 *
 * viewBox is cropped to the artwork's measured ink bounds so the mark fills the
 * line height; width/height keep that aspect ratio for `width: auto` callers.
 */
const TikTokColorIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 2010 2272" width="16" height="18">
      <path
        fill="#25f4ee"
        d="M779.38 890.55v-88.12a650.81 650.81 0 0 0-92.45-7.94c-299.8-.64-565.22 193.64-655.25 479.6S47.92 1871.34 294 2042.56a684.7 684.7 0 0 1 485.36-1152z"
      />
      <path
        fill="#25f4ee"
        d="M796 1888.72c167.62-.23 305.4-132.28 312.74-299.74V94.62h273A512.17 512.17 0 0 1 1373.8 0h-373.41v1492.92c-6.21 168.31-144.32 301.63-312.74 301.9a317.76 317.76 0 0 1-144.45-36.11A313.48 313.48 0 0 0 796 1888.72zM1891.66 601.64v-83.06a509.85 509.85 0 0 1-282.4-85.22 517.79 517.79 0 0 0 282.4 168.28z"
      />
      <path
        fill="#fe2c55"
        d="M1609.26 433.36a514.19 514.19 0 0 1-127.84-339.47h-99.68a517.16 517.16 0 0 0 227.52 339.47zM686.93 1167.9a313.46 313.46 0 0 0-144.46 590.81A312.75 312.75 0 0 1 796 1262.51a329.69 329.69 0 0 1 92.44 14.49V897.05a654.77 654.77 0 0 0-92.44-7.22h-16.62v288.9a321.13 321.13 0 0 0-92.45-10.83z"
      />
      <path
        fill="#fe2c55"
        d="M1891.66 601.64v288.91a886.23 886.23 0 0 1-517.86-168.29v759.1c-.8 378.78-308.09 685.43-686.87 685.43A679.65 679.65 0 0 1 294 2042.56 685.43 685.43 0 0 0 1481.42 1576V819.05A887.71 887.71 0 0 0 2000 985.17v-372a529.59 529.59 0 0 1-108.34-11.53z"
      />
      <path
        fill="#fff"
        d="M1373.8 1481.36v-759.1a886.11 886.11 0 0 0 518.58 166.12v-288.9a517.87 517.87 0 0 1-283.12-166.12 517.16 517.16 0 0 1-227.52-339.47h-273V1589a313.46 313.46 0 0 1-567 171.17 313.46 313.46 0 0 1 144.46-590.83 321.35 321.35 0 0 1 92.45 14.45V894.88A684.71 684.71 0 0 0 293.29 2050.5a679.65 679.65 0 0 0 393.64 116.29c378.78 0 686.07-306.65 686.87-685.43z"
      />
    </svg>
  );
};

export default TikTokColorIcon;
